module.exports = __webpack_public_path__ + "static/media/sample_vehicle_details_no_zone.141efd83.csv";